import React from 'react';
import type { WaitingStatus } from '../../types/waiting';
import styles from './WaitingStatusBadge.module.css';

interface WaitingStatusBadgeProps {
  status: WaitingStatus;
}

const STATUS_CONFIG: Record<WaitingStatus, { label: string; className: string }> = {
  WAITING: { label: '대기중', className: styles.waiting },
  CALLED: { label: '호출됨', className: styles.called },
  SEATED: { label: '입장', className: styles.seated },
  NO_SHOW: { label: '노쇼', className: styles.noShow },
  CANCELLED: { label: '취소', className: styles.cancelled },
};

export default function WaitingStatusBadge({ status }: WaitingStatusBadgeProps) {
  const config = STATUS_CONFIG[status];

  return (
    <span className={`${styles.badge} ${config.className}`}>
      {config.label}
    </span>
  );
}
